import * as platform from "platform";

class Metadata {
  public static getMetadata(options: {
    clientMetadata: Metadata;
  }): Record<string, unknown> {
    const overrides =
      options && options.clientMetadata ? options.clientMetadata : {};

    const fieldNames = [
      "ver",
      "env",
      "envv",
      "os",
      "osv",
      "osa",
      "type",
      "sdk",
      "sdkv",
      "dev",
      "devv",
      "devt",
      "app",
      "appv",
    ];
    const defaults = {
      env: platform.name ?? "unknown",
      envv: platform.version ?? "unknown",
      os: platform.os?.family ?? "unknown",
      osv: platform.os?.version ?? "unknown",
      osa: platform.os?.architecture ?? "unknown",
      sdk: "js-default",
    };

    const finalClientMetadata = {};
    fieldNames
      .filter((key) => key in overrides || key in defaults)
      .forEach(
        (key) =>
          (finalClientMetadata[key] =
            key in overrides ? overrides[key] : defaults[key])
      );

    return finalClientMetadata;
  }
}

export { Metadata };
